import React, { ReactElement } from 'react'
import { RADOM_COLORS } from '../util/Constants'
import styled from 'styled-components'
import Checkmark from '../icons/Checkmark'

interface IProps {
  disabled?: boolean
  checked: boolean
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  size?: number
  isRadio?: boolean
}

const CheckboxWrapper = styled.div<{ isChecked: boolean, isRadio: boolean, size: number }>`
  background-color: ${({ isChecked }) => isChecked ? RADOM_COLORS.NEW_BLUE : '#FFF'};
  border: 1px solid;
  border-color: ${({ isChecked }) => isChecked ? RADOM_COLORS.NEW_BLUE : RADOM_COLORS.GRAY_DARK};
  border-radius: ${({ isRadio }) => isRadio ? '100%' : '5px'};
  ${({ size }) => `
    min-width: ${size}px;
    max-width: ${size}px;
  `}
  ${({ size }) => `
    min-height: ${size}px;
    max-height: ${size}px;
  `}
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease all;
  position: relative;
  
  :focus-within {
    box-shadow: 0 0 5px ${RADOM_COLORS.NEW_BLUE};
  }
  
  &:hover {
    border-color: ${RADOM_COLORS.NEW_BLUE};
  }

  &:active {
    opacity: 0.5;
  }
`
const CheckboxInput = styled.input<{ isChecked: boolean }>`
  cursor: pointer;
  appearance: none;
  width: 100%;
  height: 100%;
  outline: none;
`

export default class Checkbox extends React.Component<IProps> {
  render(): ReactElement {
    return <CheckboxWrapper
      size={this.props.size ?? 20}
      isRadio={!!this.props.isRadio}
      isChecked={this.props.checked}
      onClick={e => {
        if (!this.props.disabled) {
          this.props.onClick?.(e)
        }
      }}>
      <CheckboxInput
        disabled={this.props.disabled}
        onChange={() => {}}
        type="checkbox"
        name="toggle"
        checked={this.props.checked}
        isChecked={this.props.checked} />
      {this.props.checked && <Checkmark color='white' animationDelay='0' style={{ width: 20, height: 20, position: 'absolute', userSelect: 'none' }} /> }
    </CheckboxWrapper>
  }
}
